<template>
  <Dialog :open="isOpen" @update:open="closeModal">
    <DialogContent class="max-w-md z-[3000] [&>button]:hidden" overlay-class="z-[3000]">
      <DialogHeader>
        <DialogTitle class="text-lg font-bold text-gray-900 dark:text-white">
          Samsung Browser Warning
        </DialogTitle>
      </DialogHeader>

      <div class="space-y-4 text-sm text-gray-700 dark:text-gray-300">
        <p>
          You appear to be using Samsung Browser with <strong>Forced Dark Mode</strong> active, this can have a visual impact on the site.
        </p>
        <p>
          We suggest switching off Forced dark mode by going to:
          <span class="block mt-1 font-semibold text-gray-900 dark:text-white bg-gray-100 dark:bg-zinc-800 p-2 rounded">
            Settings &rarr; Webpage view and scrolling &rarr; Dark Mode &rarr; Force Dark mode for web content
          </span>
        </p>
        <div class="flex items-center gap-2 flex-wrap">
          <span>Or installing the native app:</span>
          <a
            href="https://play.google.com/store/apps/details?id=com.voxbet.mobile.prod.app.betpic"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 px-3 py-1.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 font-medium transition-colors text-xs font-semibold"
          >
            <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.523 15.3c-.328 0-.593-.266-.593-.593 0-.327.265-.592.593-.592.327 0 .592.265.592.592 0 .327-.265.593-.592.593m-11.046 0c-.328 0-.593-.266-.593-.593 0-.327.265-.592.593-.592.327 0 .592.265.592.592 0 .327-.265.593-.592.593M17.6 11.23l1.83-3.17a.38.38 0 00-.14-.52.38.38 0 00-.52.14l-1.85 3.2C15.39 9.85 13.75 9.2 12 9.2c-1.75 0-3.39.65-4.92 1.68l-1.85-3.2a.38.38 0 00-.52-.14.38.38 0 00-.14.52l1.83 3.17C2.91 13.11 1 16.03 1 19.4h22c0-3.37-1.91-6.29-5.4-8.17z"/>
            </svg>
            Google Play
          </a>
          <span>or using another browser.</span>
        </div>
      </div>

      <DialogFooter class="mt-4 flex flex-col gap-2">
        <Button class="w-full" @click="closeModal">
          Dismiss
        </Button>
        <Button variant="outline" class="w-full text-xs" @click="dismissPermanently">
          Don't show again
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Dialog from '@/components/ui/dialog/Dialog.vue'
import DialogContent from '@/components/ui/dialog/DialogContent.vue'
import DialogHeader from '@/components/ui/dialog/DialogHeader.vue'
import DialogTitle from '@/components/ui/dialog/DialogTitle.vue'
import DialogFooter from '@/components/ui/dialog/DialogFooter.vue'
import Button from '@/components/ui/button/Button.vue'

const isOpen = ref(false)

const closeModal = () => {
  isOpen.value = false
}

const dismissPermanently = () => {
  localStorage.setItem('samsung_forced_dark_dismissed', 'true')
  isOpen.value = false
}

onMounted(() => {
  const ua = navigator.userAgent
  const isSamsung = /SamsungBrowser/i.test(ua)
  const isMobile = /Mobi|Android/i.test(ua)
  const isDismissed = localStorage.getItem('samsung_forced_dark_dismissed') === 'true'

  if (isSamsung && isMobile && !isDismissed) {
    isOpen.value = true
  }
})
</script>
